import {
  ACCOUNT_TITLE,
  BACKUP,
  CONTACT,
  COST_CENTER,
  HASHTAG,
  PROJECT_PROFILE,
  PROJECT_SETTING,
  PROJECTS_MANAGEMENT,
  TRANSACTIONS_IMPORT_EXCEL,
  USER_ACCOUNT_SETTING
} from "./urls";
import { PROJECT_USER_ROLES } from "./projectUser";
import {
  ACCOUNT_TITLE_ICON,
  BACKUP_ICON,
  CONTACT_ICON,
  COST_CENTER_ICON,
  HASHTAG_ICON,
  PROJECT_SETTING_ICON,
  PROJECTS_MANAGEMENT_ICON,
  UPLOAD_FROM_EXCEL_ICON,
  USER_MANAGEMENT_ICON,
  USER_SETTING_ICON
} from "./icons";
import { getPanel } from "../assets/selectProjectUserOrPanel";
import { CUSTODIAN_PANEL } from "./panelTypes";
import {IMPORT_TRANSACTIONS} from "./premiumActions";

export const TOOL_OPTIONS_GROUPS = (panel, history, project) => [
  {
    title: "حساب کاربری من",
    list: [
      {
        key: 1,
        value: "تنظیمات حساب کاربری",
        link: USER_ACCOUNT_SETTING,
        icon: USER_SETTING_ICON
      },
      {
        key: 2,
        value: "لیست شرکت‌ها",
        link: PROJECTS_MANAGEMENT,
        icon: PROJECTS_MANAGEMENT_ICON
      },
      {
        key: 3,
        value: "مدیریت اعضای شرکت‌ها",
        action: ActionTypes.TEAM_MANAGEMENT,
        icon: USER_MANAGEMENT_ICON
      }
    ]
  },
  {
    title: `تنظیمات شرکت ${project.name}`,
    list: [
      {
        key: 4,
        value: "تنظیمات عمومی شرکت",
        link: PROJECT_SETTING,
        icon: PROJECT_SETTING_ICON
      },
      {
        key: 5,
        value: "مدیریت اعضا",
        link: `${PROJECT_PROFILE}/${project.id}`,
        icon: USER_MANAGEMENT_ICON,
        accesses: [
          PROJECT_USER_ROLES.OWNER,
          PROJECT_USER_ROLES.ADMIN,
          PROJECT_USER_ROLES.MANAGER
        ]
      },
      {
        key: 6,
        value: panel.title,
        link: panel.link,
        action: ActionTypes.SWITCH_PANEL,
        accesses: panel.accesses,
        icon: panel.icon
      },
      {
        key: 7,
        value: "لیست سرفصل‌های حساب",
        link: ACCOUNT_TITLE,
        icon: ACCOUNT_TITLE_ICON
      },
      {
        key: 8,
        value: "لیست مراکز هزینه",
        link: COST_CENTER,
        icon: COST_CENTER_ICON
      },
      {
        key: 9,
        value: "لیست طرف حساب‌ها",
        link: CONTACT,
        icon: CONTACT_ICON
      },
      {
        key: 10,
        value: "لیست هشتگ‌ها",
        link: HASHTAG,
        SvgIcon: HASHTAG_ICON
      },
      {
        key: 11,
        value: "بارگذاری تراکنش‌ها از اکسل",
        premium: IMPORT_TRANSACTIONS,
        link: TRANSACTIONS_IMPORT_EXCEL,
        icon: UPLOAD_FROM_EXCEL_ICON,
        hide: getPanel() !== CUSTODIAN_PANEL
      },
      {
        key: 12,
        value: "تهیه نسخه پشتیبان",
        link: BACKUP,
        accesses: [
          PROJECT_USER_ROLES.OWNER,
          PROJECT_USER_ROLES.ADMIN,
          PROJECT_USER_ROLES.MANAGER
        ],
        icon: BACKUP_ICON
      }
    ]
  }
];
export const ActionTypes = {
  TEAM_MANAGEMENT: "team_management",
  SWITCH_PANEL: "switch_panel"
};
